export const RETRIEVE_INTERLOCUTORS_REQUEST = "RETRIEVE_INTERLOCUTORS_REQUEST"
export const RETRIEVE_INTERLOCUTORS_SUCCESS = "RETRIEVE_INTERLOCUTORS_SUCCESS"
export const RETRIEVE_INTERLOCUTORS_FAILURE = "RETRIEVE_INTERLOCUTORS_FAILURE"
